<template>
    <div class="selection multipleSelection" v-bind:class="leg.isLive ? 'live' : ''">
        <component
            v-bind:is="isNeedDelStatus ? 'del' : 'div'"
        >
            <ul>
                <li>
                    <strong>{{ leg.marketType.name }}</strong>
                </li>
                <li class="betOption">
                    <span class="contentGroup">
                        {{ leg.betTeam }}
                    </span>
                    <span v-if="pointDisplay" class="contentGroup">
                        @ {{ pointDisplay }}
                    </span>
                    <span v-if="liveScoreDisplay" class="contentGroup">
                        @ {{ liveScoreDisplay }}
                    </span>
                    <span v-if="isDisplayParlayFinalPrice" class="contentGroup subContent">
                        @ {{ statusDisplay }}
                    </span>
                </li>
            </ul>
        </component>
    </div>
</template>

<script lang="ts" setup>
    import { computed, toRefs } from 'vue';
    import { invalidSubBetStatusList } from '@/components/myBets/betHelper';
    import { getSubBetStatusResultsDisplay } from '@/components/myBets/useBetBuilderBetDisplay';
    import { useBetBuilderLegLiveScore } from '@/components/myBets/useBetBuilderLegLiveScore';
    import { getLegPointDisplay } from '@/core/lib/betBuilderHelper';
    import type { IBetBuilderLeg } from '@/interface/betBuilder';

    const props = defineProps<{
        leg: IBetBuilderLeg;
        isInvalidStatus: boolean;
        isDisplayParlayFinalPrice: boolean;
    }>();

    const { leg, isInvalidStatus, isDisplayParlayFinalPrice } = toRefs(props);

    const statusDisplay = computed(() => (
        isDisplayParlayFinalPrice.value ? getSubBetStatusResultsDisplay(leg.value.status) : ''
    ));

    const isNeedDelStatus = computed(() => invalidSubBetStatusList.includes(leg.value.status) || isInvalidStatus.value);

    const pointDisplay = computed(() => getLegPointDisplay(leg.value));
    const { liveScoreDisplay } = useBetBuilderLegLiveScore(leg);
</script>

<style lang="scss" scoped>
    @import "@/components/myBets/Selection";
</style>
